import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { formatPrice, localized } from "@/lib/api";
import { toast } from "sonner";

export default function Subscriptions() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/subscriptions/me");
      setSubs(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const cancel = async (id) => {
    if (!window.confirm(t("subscriptions.cancelConfirm"))) return;
    try {
      await api.post(`/subscriptions/${id}/cancel`);
      toast.success(t("subscriptions.cancelled"));
      load();
    } catch { toast.error(t("subscriptions.cancelFailed")); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="subscriptions-page">
      <p className="overline">{t("subscriptions.overline")}</p>
      <h1 className="font-serif text-5xl tracking-tight mt-2">{t("subscriptions.title")}</h1>
      <p className="text-ink-soft mt-3 max-w-xl">{t("subscriptions.subtitle")}</p>

      {loading ? (
        <p className="mt-12 text-ink-muted">{t("common.loading")}</p>
      ) : subs.length === 0 ? (
        <div className="mt-16 bg-boneAlt rounded-sm py-20 text-center" data-testid="subs-empty">
          <p className="font-serif text-2xl">{t("subscriptions.empty")}</p>
          <Link to="/shop" className="inline-block mt-6 bg-olive text-bone px-6 py-3 rounded-sm text-sm">{t("subscriptions.browse")}</Link>
        </div>
      ) : (
        <div className="space-y-4 mt-12" data-testid="subs-list">
          {subs.map((s) => (
            <div key={s.subscription_id} className="bg-white hairline rounded-sm p-6 flex justify-between items-center flex-wrap gap-4" data-testid={`sub-${s.subscription_id}`}>
              <div className="flex gap-4 items-center">
                {s.product?.images?.[0] && (
                  <div className="w-20 h-20 bg-boneAlt rounded-sm overflow-hidden">
                    <img src={s.product.images[0]} alt="" className="w-full h-full object-cover" />
                  </div>
                )}
                <div>
                  <p className="overline">{s.cadence} · {s.status}</p>
                  <h3 className="font-serif text-xl mt-1">{localized(s.product, "title", lang)}</h3>
                  <p className="text-sm text-ink-soft">{s.product?.vendor_name}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-medium">{formatPrice(s.unit_amount, s.currency === "eur" ? "hr" : "en")} <span className="text-xs text-ink-muted">{t("subscriptions.perDelivery")}</span></p>
                {s.status === "active" && (
                  <button onClick={() => cancel(s.subscription_id)} className="text-xs text-terracotta hover:underline mt-2" data-testid={`cancel-${s.subscription_id}`}>
                    {t("subscriptions.cancelSub")}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
